import {Component, inject, OnInit} from '@angular/core'
import {FormControl, ReactiveFormsModule} from '@angular/forms'
import {MatOption} from '@angular/material/core'
import {MatFormField, MatLabel} from '@angular/material/form-field'
import {MatSelect} from '@angular/material/select'
import {Router} from '@angular/router'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'
import {ControlService} from '../../services/control.service'
import {DataService} from '../../services/data.service'
import {KalpService, Scenarios} from '../../services/kalp.service'

@Component({
  selector: 'spb-scenario',
  templateUrl: './scenario.component.html',
  styleUrls: ['./scenario.component.scss'],
  imports: [MatFormField, MatLabel, MatSelect, ReactiveFormsModule, MatOption]
})
export class ScenarioComponent implements OnInit {

  public scenariosCtrl = [Scenarios.Purchase, Scenarios.Increase, Scenarios.Transfer, Scenarios.Conditions]

  public scenario = new FormControl<Scenarios | null>(null)

  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  private readonly dataService = inject(DataService)
  private readonly kalpService = inject(KalpService)
  private readonly controlService = inject(ControlService)
  private readonly router = inject(Router)

  public ngOnInit(): void {
    this.kalpService.scenarioChange$
      .pipe(this.takeUntilDestroyed())
      .subscribe(scenario => {
        this.scenario.setValue(scenario, {emitEvent: false})
        this.controlService.scenarioSelected$.next(!!scenario)
      })

    this.scenario.valueChanges.subscribe(s => {
      // Workaround: Navigate to force complete component reset, clearing old
      // building data that appears when data$ emits after scenarioChange$
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.dataService.reset()
        this.kalpService.scenarioChange$.next(s)
        this.controlService.scenarioSelected$.next(true)
      })
    })
  }
}
